import { VISITOR } from '@/models/session';
import { Session } from '@/models/user';
import { gaPushEvent, GTagEventData } from '@/utils/analytics';
import { createContext, Dispatch, SetStateAction } from 'react';

interface SessionContextProps {
  session: Session;
  isAuthenticated: boolean;
  orgIndex: number;
  setOrgIndex: Dispatch<SetStateAction<number>>;
  setSession: Dispatch<SetStateAction<Session>>;
  logout: () => Promise<void>;
  refreshSession: () => Promise<void>;
  refreshThreads: () => void;
  pushUserEvent: (action: string, data?: GTagEventData) => void;
}

const SessionContext = createContext<SessionContextProps>({
  session: VISITOR,
  isAuthenticated: false,
  setSession: () => {},
  orgIndex: 0,
  setOrgIndex: () => {},
  logout: async () => {},
  refreshSession: async () => {},
  refreshThreads: () => {},
  pushUserEvent: (action: string, data: GTagEventData = {}): void => {
    gaPushEvent(action, '', data);
  },
});

export default SessionContext;
